<owl-carousel-o [options]="BlogSliderConfig" class="no-arrow">
  <ng-container *ngFor="let blog of blogs">
    <ng-template carouselSlide>
      <div class="col-md-12">
        <a routerLink="/islamic-center/managers/{{blog.id}}">
          <div class="classic-effect">
            <img [src]="blog.imageUrl" class="img-fluid" alt="blog" style="height: 200px;">
            <span></span>
          </div>
        </a>
        <div class="blog-details">
          <!-- <h4>{{blog.date}}</h4> -->
          <a routerLink="/islamic-center/managers/{{blog.id}}">
            <p>{{lang==='ar-EG'?blog.nameAr:blog.nameEn}}</p>
          </a>
          <hr class="style1">
          <!-- <h6> {{ 'by:' +blog.by}} , {{ '2 Comment' }}</h6> -->
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>